import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-romaneio-date-range-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './romaneio-date-range-modal.html',
  styleUrls: ['./romaneio-date-range-modal.css']
})
export class RomanieioDaterRangeModalComponent {
  @Output() dateRangeSelected = new EventEmitter<{ inicio: string; fim: string }>();
  @Output() closed = new EventEmitter<void>();

  dataInicio: string = '';
  dataFim: string = '';
  isOpen = false;

  constructor(private toastr: ToastrService) {
    // Set default dates to today
    const today = new Date();
    this.dataInicio = this.formatDateForInput(today);
    this.dataFim = this.formatDateForInput(today);
  }

  open(): void {
    this.isOpen = true;
  }

  close(): void {
    this.isOpen = false;
    this.closed.emit();
  }

  private formatDateForInput(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  private formatDateForAPI(dateString: string): string {
    if (!dateString) return '';
    // Extrai diretamente da string para evitar deslocamento de fuso UTC
    const [year, month, day] = dateString.split('-');
    return `${year}-${month}-${day}`;
  }

  private formatDateForAPIEnd(dateString: string): string {
    if (!dateString) return '';
    // Extrai diretamente da string para evitar deslocamento de fuso UTC
    const [year, month, day] = dateString.split('-');
    return `${year}-${month}-${day}`;
  }

  submit(): void {
    // Validate dates
    if (!this.dataInicio || !this.dataFim) {
      this.toastr.error('Por favor, selecione ambas as datas.');
      return;
    }

    const dataInicioDate = new Date(this.dataInicio);
    const dataFimDate = new Date(this.dataFim);

    if (dataFimDate < dataInicioDate) {
      this.toastr.error('A data de fim não pode ser anterior à data de início.');
      return;
    }

    const dataInicioAPI = this.formatDateForAPI(this.dataInicio);
    const dataFimAPI = this.formatDateForAPIEnd(this.dataFim);

    this.dateRangeSelected.emit({
      inicio: dataInicioAPI,
      fim: dataFimAPI
    });

    this.close();
  }

  cancel(): void {
    this.close();
  }
}
